import React from 'react';

export const Chat = ({ width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.35078 13.9985L3.6247 17.779C2.96993 18.3028 2 17.8366 2 16.9982V4.99972C2 3.34302 3.34315 2 5 2H15C16.6569 2 18 3.34302 18 4.99972V10.9988C18 12.6555 16.6569 13.9985 15 13.9985H8.35078Z"
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
